module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__cta--container"
  }, _vm._l((_vm.sharedState.currentStep.stickyNavigationOptions.buttons), function(button) {
    return _c('div', {
      class: [{
        'disabled-button': _vm.currentStepValidation(button.requireStepValidation)
      }, button.buttonClass],
      attrs: {
        "data-link": button.linkTo
      },
      on: {
        "click": _vm.handleButtonClick
      }
    }, [_vm._v("\n    " + _vm._s(button.text) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2e4ccfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/stickyFooterNavigation.vue
// module id = 432
// module chunks = 1